module.exports = __webpack_public_path__ + "static/images/ckbx.51eae80af.png";